import React from 'react';
import Banner from '../../../UI/Banner/Banner';
import bannerImage from "../../../../assets/images/products-banner/Software-Papel-Comercial.png";
import bannerImageWebpp from "../../../../assets/images/products-banner/Software-Papel-Comercial.webp";

const ComercialPaperBanner = props => (
        <Banner 
            id="comercialPaper-banner" 
            className="banner black pb-5 products-banner" 
            title="products:comercialPaper:section-1.title"
            text="products:comercialPaper:section-1.txt"
            t={props.t} 
            imageBannerRight={bannerImage} 
            imageBannerRightWebp={bannerImageWebpp}
            timeDelay={1.55} 
        />
);

export default ComercialPaperBanner;